
export const translations = {
    title:'Banners',
    menu: [{id:1, label:'Tienda'}, {id:2, label:'Promocional'}, {id:3, label:'Telemedicina'}],
}